import { Component, OnInit } from '@angular/core';
import { ProgramsService } from '../services/programs.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { NavController, AlertController, PopoverController } from '@ionic/angular';

export interface ChannelInt {
  heroesUrl: string;
  textfile: string;
}


@Component({
  selector: 'app-channels',
  templateUrl: './channels.component.html',
  styleUrls: ['./channels.component.scss'],
})
export class ChannelsComponent implements OnInit {
  channels: any;
  channelList: any;
  testVariable: string;
  data: any;
  channelId: string;
  config: any;

  constructor(
    private channelService: ProgramsService,
    public navCtrl: NavController,
    private router: Router,
    private route: ActivatedRoute,
    public alertController: AlertController,
    private popoverController: PopoverController) {
  }

  ngOnInit() {
    this.channelService.getChannelsApi()
    .subscribe((data: ChannelInt) => this.channelList = {
      title: (data as any).title,
      channelDescription: (data as any).channel_description,
      channelImage: (data as any).channel_image,
      elearningChannel: (data as any).elearning_channel,
      id: (data as any).id,
      randomize: (data as any).randomize,
      ordering: (data as any).ordering,
      baseUrl: (data as any).base_url,
      programs: (data as any).programs,
      state: (data as any).state,
      subscriptionRequired: (data as any).subscription_required,
      broadcastType: (data as any).broadcast_type
    });
  }

  async getDescription(title, channelDescription) {
    const alert = await this.alertController.create({
      header: title,
      subHeader: 'Description',
      message: channelDescription,
      buttons: ['X']
    });

    await alert.present();
  }

  shuffle(array) {
    let currentIndex = array.length, temporaryValue, randomIndex;
  
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
  
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
  
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
  
    return array;
  }

  openDetailsWithState(id, title, description, programs, elearningChannel, baseUrl, usergroup, broadcastType, randomize, channelImage) {
    const channelDetails = {
      id: id,
      title: title,
      description: description,
      programs: programs,
      elearningChannel: elearningChannel,
      baseUrl: baseUrl,
      usergroup: usergroup,
      broadcastType: broadcastType,
      randomize: randomize,
      channelImage: channelImage
    };
    const navigationExtras: NavigationExtras = {
      state: {
        channel: channelDetails
      }
    };
    this.router.navigate(['media-player'], navigationExtras);
  }

  goTocard() {
    this.router.navigate(['card-form']);
  }

}
